<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">That worked!</h1>
			<p>
				Your item was canceled successfully!
			</p>

		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';

	export default {
		name: "CanceledSuccessfully",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>